export default class Image {
  /**
   * Create a CDN URL (similar to the img_url filter in Liquid)
   */
  getSizedImageUrl(src, size) {
    if (size === null) {
      return src
    }

    if (size === 'master') {
      return src.replace(/http(s)?:/, '')
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i)

    if (match) {
      var prefix = src.split(match[0])
      var suffix = match[0]

      return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '')
    } else {
      return null
    }
  }

  /**
   * From a given set of desired sizes and a given image, filter out any unwanted sizes
   */

  getSupportedSizes(image, desiredSizes) {
    var supportedSizes = [],
        imageWidth = image['width']

    desiredSizes.forEach(function (width) {
      if (imageWidth >= width) {
        supportedSizes.push(width)
      }
    })

    return supportedSizes
  }
}